import { DateTime } from 'luxon';
import { DisabledDaysWithMessage } from '../../commonTypes/acs';
import { useResizeListener } from '../../hooks/windowEvents/useResizeListener';
import { useEffect, useState } from 'react';
import { Calendar } from '../Common';

interface ICalendarFixedRangePickerProps {
    disabledDays: DisabledDaysWithMessage[];
    onPeriodChange: (from: string, to: string) => void;
    fixedRangeStart: DateTime;
    fixedRangeEnd: DateTime;
    onEndDateChange: (newEndDate: DateTime) => void;
    endDate: DateTime;
}

const CalendarFixedRangePicker = ({
    disabledDays,
    onPeriodChange,
    fixedRangeStart,
    fixedRangeEnd,
    onEndDateChange,
    endDate,
}: ICalendarFixedRangePickerProps) => {
    const [displayDateCalendarLeft, setDisplayDateCalendarLeft] = useState(DateTime.now().startOf('day'));
    const [displayDateCalendarRight, setDisplayDateCalendarRight] = useState(DateTime.now().startOf('day'));

    const isSecondCalendarActive = !useResizeListener().isMaxWidthMedium;

    useEffect(() => {
        onPeriodChange(displayDateCalendarLeft.startOf('month').toISO(), displayDateCalendarLeft.plus({ month: 1 }).endOf('month').toISO());
    }, [displayDateCalendarLeft.toISO(), displayDateCalendarRight.toISO()]);

    const handleDisplayDate = (_changeDate: DateTime, nextBackAction?: string) => {
        if (nextBackAction === 'right') {
            setDisplayDateCalendarLeft(prev => prev.plus({ months: 1 }));
            setDisplayDateCalendarRight(prev => prev.plus({ months: 1 }));
        }

        if (nextBackAction === 'left') {
            setDisplayDateCalendarLeft(prev => prev.minus({ months: 1 }));
            setDisplayDateCalendarRight(prev => prev.minus({ months: 1 }));
        }
    };

    const changeDate = (selectedDate: DateTime) => {
        if (selectedDate.startOf('day') < fixedRangeEnd.startOf('day') && selectedDate.startOf('day') >= DateTime.now().startOf('day')) {
            onEndDateChange(selectedDate.startOf('day'));
        }
    };

    return (
        <div className="data-range-picker">
            <Calendar
                displayDate={displayDateCalendarLeft}
                changeMonth={handleDisplayDate}
                startDate={fixedRangeStart}
                endDate={endDate}
                onClick={changeDate}
                activeArrows={{
                    active: true,
                    firstCalendarLeftButton: true,
                    secondCalendarRightButton: !isSecondCalendarActive,
                }}
                disabledDays={disabledDays}
                disableAfterEndDate
            />
            {isSecondCalendarActive && (
                <Calendar
                    displayDate={displayDateCalendarRight.plus({ month: 1 })}
                    changeMonth={handleDisplayDate}
                    onClick={changeDate}
                    startDate={fixedRangeStart}
                    endDate={endDate}
                    activeArrows={{
                        active: true,
                        secondCalendarRightButton: true,
                    }}
                    disabledDays={disabledDays}
                    disableAfterEndDate
                />
            )}
        </div>
    );
};

export default CalendarFixedRangePicker;
